module.exports = __webpack_public_path__ + "img/firefox.a8f82844.svg";